export enum DivisionStatus {
	Trial = "trial",
	Active = "active",
	Deactivated = "deactivated",
	Archived = "archived",
}
